export default ["Animals", "Cool Stuff", "Cute", "Fails", "Heartwarming", "Humor", "Newsworthy"];
